// Kingly logo — Regal Monogram.
// A serif "K" capped with a small 3-point crown, set in a deep-navy medallion
// with a champagne-gold double ring. Renders crisp at any size.
import { useId } from "react";

export default function KinglyLogo({ className = "", size = 28, ...props }) {
  const uid = useId().replace(/:/g, "");
  const gold = `kingly-gold-${uid}`, navy = `kingly-navy-${uid}`, sheen = `kingly-sheen-${uid}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      {...props}
    >
      <defs>
        <linearGradient id={gold} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F7E3A1" />
          <stop offset="45%" stopColor="#D9B266" />
          <stop offset="100%" stopColor="#8A6321" />
        </linearGradient>
        <linearGradient id={navy} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1E293B" />
          <stop offset="100%" stopColor="#0B1322" />
        </linearGradient>
        <radialGradient id={sheen} cx="0.3" cy="0.25" r="0.9">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.18" />
          <stop offset="60%" stopColor="#FFFFFF" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Medallion */}
      <circle cx="32" cy="32" r="30" fill={`url(#${navy})`} />
      {/* Subtle inner sheen */}
      <circle cx="32" cy="32" r="30" fill={`url(#${sheen})`} />
      {/* Outer gold ring */}
      <circle cx="32" cy="32" r="30" fill="none" stroke={`url(#${gold})`} strokeWidth="1.6" />
      {/* Inner hairline ring */}
      <circle cx="32" cy="32" r="26.5" fill="none" stroke={`url(#${gold})`} strokeWidth="0.4" opacity="0.55" />

      {/* Crown — three points with gem dots */}
      <path
        d="M22.5 18.5 L25.5 13.5 L28.5 17 L32 11.5 L35.5 17 L38.5 13.5 L41.5 18.5 L40.6 21.3 L23.4 21.3 Z"
        fill={`url(#${gold})`}
        stroke="#3C2A0F"
        strokeWidth="0.35"
        strokeLinejoin="round"
      />
      {/* Crown band */}
      <rect x="23" y="20.9" width="18" height="1.4" fill="#3C2A0F" opacity="0.6" />
      {/* Gem highlights */}
      <circle cx="28.5" cy="17.4" r="0.85" fill="#FFF5D1" />
      <circle cx="32" cy="15.2" r="1" fill="#FFF5D1" />
      <circle cx="35.5" cy="17.4" r="0.85" fill="#FFF5D1" />

      {/* Stylized serif K */}
      {/* Vertical stem with subtle serifs */}
      <path
        d="M20 25.5
           L28 25.5
           L28 27
           L26.6 27
           L26.6 49
           L28 49
           L28 50.5
           L20 50.5
           L20 49
           L21.4 49
           L21.4 27
           L20 27
           Z"
        fill={`url(#${gold})`}
        stroke="#3C2A0F"
        strokeWidth="0.3"
        strokeLinejoin="round"
      />
      {/* Upper diagonal arm with serif tip */}
      <path
        d="M26.6 37.4
           L38.6 25.5
           L44.2 25.5
           L44.2 27
           L42.6 27
           L31.2 38.4
           L28.6 38.4
           Z"
        fill={`url(#${gold})`}
        stroke="#3C2A0F"
        strokeWidth="0.3"
        strokeLinejoin="round"
      />
      {/* Lower diagonal arm with serif tip */}
      <path
        d="M30.2 37.2
           L43.6 50.5
           L37.6 50.5
           L36 49
           L26.6 39.7
           Z"
        fill={`url(#${gold})`}
        stroke="#3C2A0F"
        strokeWidth="0.3"
        strokeLinejoin="round"
      />
      {/* Lower-arm serif underline */}
      <path
        d="M37.6 50.5 L44.6 50.5 L44.6 49 L42.6 49 L41 47.4 L38.4 47.4 Z"
        fill={`url(#${gold})`}
        stroke="#3C2A0F"
        strokeWidth="0.3"
        strokeLinejoin="round"
      />

      {/* Tiny gold pinpoints flanking the crown for balance */}
      <circle cx="14" cy="32" r="0.9" fill={`url(#${gold})`} />
      <circle cx="50" cy="32" r="0.9" fill={`url(#${gold})`} />
    </svg>
  );
}
